// extracted by mini-css-extract-plugin
export default {"statistics_number":"DashboardRewardReceived_statistics_number__lnjPj"};